<template>
<m-pageframe
    title="Compliance Archives"
>
<v-container
    fluid
>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        style="margin-top: 15px;"

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"

    >

        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint')}}
        </template>


        <template v-slot:item.hashes="{ item }">
            <div
                style="text-align: left;
                font-family: monospace;
                font-size: 12px;
                "
            >
                <b>MD5:</b>{{item.hashes.md5}}<br/>
                <b>SHA-1:</b>{{item.hashes.sha_1}}<br/>
                <b>SHA-256:</b>{{item.hashes.sha_256}}<br/>
            </div>
        </template>

        <template v-slot:item.download="{ item }">
            <div
                style="text-align: center;"
            >
            <v-icon
                v-on:click="onClickDownload(item)"
            >
                mdi-download
            </v-icon>
            </div>
        </template>

     </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            results: [],

            headers: [
                { 'text' : 'Organization', 'value' : 'organization_label' },
                { 'text' : 'Date', 'value' : 'date' },
                { 'text' : 'RedChirp Number', 'value' : 'endpoint' },
                { 'text' : 'Assignment', 'value' : 'endpoint_assignment_label' },
                { 'text' : 'Format' , 'value' : 'format' },
                { 'text' : 'Fingerprint' , 'value' : 'hashes' },
                { 'text' : 'Download' , 'value' : 'download' },
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
           
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/compliance/finra/communication-log-archives',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search archive records');
                },
            );
        },

        onClickDownload(item)
        {
            let url = 'compliance/download/'+item.organization_id+"/"+item.endpoint+"/"+item.date+"/"+item.format+"/"+item.hashes.md5;

            url = this.$rc.getAPIEndpoint(url);

            window.open(url, '_blank');
        },
    },
}
</script>

<style lang="scss" scoped>
</style>